import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';


export default function TurmaDisciplinaProfessorProfileInfo({ tdp }) {


    return (
        <Grid container spacing={3}>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Turma
                </Typography>
                <Typography variant="body1">
                    {tdp.turma.descricao}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Disciplina
                </Typography>
                <Typography variant="body1">
                    {tdp.disciplina.descricao}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Professor
                </Typography>
                <Typography variant="body1">
                    {tdp.usuario ? tdp.usuario.nome : 'Preencher'}
                </Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="body1" color="textSecondary" gutterBottom>
                    Livro
                </Typography>
                <Typography variant="body1">
                    {tdp.livro ? tdp.livro.descricao : 'Preencher'}
                </Typography>
            </Grid>
        </Grid>
    );
}